import router from "@/router/router";
import { useExplorerStore } from "@/modules/explorer/store";
import useDialog from "@/ui/composables/useDialog";
import StoredDocumentDO = App.Data.StoredDocumentDO;

export function useDashboardRedirect() {
	/**
	 * Offers to navigate back to the dashboard the user came from
	 * (explorerState.dashboardRedirectUuid). When a newly created stored
	 * document is passed, its uuid is added to the query so the dashboard can
	 * preselect it in the add-card drawer.
	 */
	const redirectBackToDashboard = async (newDocument?: StoredDocumentDO) => {
		const dashboardUuid =
			useExplorerStore().explorerState.dashboardRedirectUuid;
		if (!dashboardUuid) return;

		const choice = await useDialog().confirm({
			title: "Redirect back to dashboard?",
			message: "Would you like to return to the dashboard you were editing?",
		});
		if (!choice) return;

		const query = newDocument
			? {
					"new-document": newDocument.uuid,
			  }
			: {};

		router.push({
			name: "dashboards.builder",
			params: {
				dashboard_uuid: dashboardUuid,
			},
			query,
		});
	};

	return {
		redirectBackToDashboard,
	};
}
